import { onViewLoad } from "~/jose_modern/on_view_load.js";
import { bindCommentFormShortcuts } from "../shared/comments.js";

const scan = (container) => {
  bindCommentFormShortcuts(container, ".recipe_comment_form");
};

onViewLoad("recipes#history", () => {
  scan(document);
  document.addEventListener("partial:replace", (ev) => scan(ev.container));
});
